<template lang="pug">
  span.verification-wrapper

    .steps
      ProgressSteps(
        :currentStep="currentStep",
        :steps="kinds",
        :currentSubStep="currentEventStep",
        @change="setVerifyKind",
      )

    .filters-box
      .problems-info(v-if="lines.length && pagination.total")
        label
          span.icon.icon-ptt-icons-alerta
          strong {{ pagination.total }}
          | &nbsp;  ocorrências

        .btn-13px(v-has-permission="{module: 'autocorrect', action: 'post', hide: true}")
          PButton(v-if="verificationKind === 'oddPts' && lines.length", color="success" size="md",
            @click="resolveOddPtsProblems", block)
            | correção automática

        .paginate
          Paginate(
            v-if="pagination.pages !== null && pagination.pages > 1",
            :totalPages="pagination.pages",
            :currentPage="pagination.page",
            @goToPage="goToPage"
          )

      template(v-if="verificationKind === 'timemeasurement'")
        PSelect(
          trackBy="field",
          @change="changeVerificationFilter"
          labelItem="text",
          title="selecionar apontamento",
          :options="apontamentos"
          v-model="apontamentoSelected"
        )

        PSelect(
          labelItem="name",
          title="selecionar evento",
          v-model="tmsQuery",
          :options="[{id: 'gte', name: 'maior ou igual a'}, {id: 'lte', name: 'menor ou igual a'}]"
        )

        PTimeCountField(v-model="filterValue", name="" @change="updateVerificationFiltersState")

        .btn-13px
          PButton(color="success" size="md", @click="verify(true)",
            :disabled="isNaN(filterValue.float) || filterValue.float < 0", block) ver

        PCheckbox.ignore-zeros(v-model="tmsIgnoreZeros", label="ignorar valores zerados")

      template(v-if="verificationKind === 'events'")
        PSelect(
          labelItem="name",
          title="selecionar evento",
          v-model="eventSelected",
          :options="events"
        )
        PCheckbox.desconto_em_banco(v-if="eventSelected === 'falta'", v-model="descontoBancoDeHoras", label="mostrar desconto de banco de horas")

        .btn-13px
          PButton(color="success" size="md", @click="changeEventType", block) ver

</template>

<script>
import { mapState } from 'vuex'
import ProgressSteps from './ProgressSteps'
import Paginate from 'src/common/pagination/Paginate'
import { range } from 'src/utils'

export default {
  data () {
    return {
      apontamentos: [
        { field: 'extraTime50Tot', text: 'hora extra' },
        { field: 'extraTime100Tot', text: 'hora extra ext.' },
        { field: 'extraTimeSpecialTot', text: 'hora extra esp.' },
        { field: 'extraTime50NotTot', text: 'hora extra not.' },
        { field: 'extraTime100NotTot', text: 'h.e. ext. not' },
        { field: 'extraTimeSpecialNotTot', text: 'h.e esp. not.' },
        { field: 'delayTime', text: 'atraso' },
        { field: 'interJourney50', text: 'h. interjornada' },
        { field: 'pause50', text: 'pausa refeição' },
        { field: 'pause100', text: 'P. Ref. Extraord' },
        { field: 'pauseSpec', text: 'P. Ref. Esp.' },
        { field: 'pause50Not', text: 'P. Ref. Not.' },
        { field: 'pause100Not', text: 'P. Ref. Extraord  Not.' },
        { field: 'pauseSpecNot', text: 'P. Ref. Esp. Not.' },
        { field: 'lunchPenalty', text: 'H. atraso de Pausa' },
        { field: 'earlyExit', text: 'H. de saídas antecipadas' }

      ],
      apontamentoSelected: 'extraTime50Tot',
      filterValue: {
        float: 1.0,
        hours: 1,
        minutes: 0
      },
      currentType: null,
      kinds: [
        { id: 'doubleLines', name: 'Dias duplicados' },
        { id: 'oddPts', name: 'Pontos para corrigir' },
        { id: 'pendency', name: 'Pendências' },
        { id: 'timemeasurement', name: 'Apontamentos' },
        { id: 'events', name: 'Eventos' }
      ],
      events: [
        { id: 'falta', name: 'Faltas' },
        { id: 'folgaTrabalhada', name: 'Folgas Trabalhadas' },
        { id: 'justify', name: 'Dispensas' },
        { id: 'suspension', name: 'Suspensões' }
      ],
      eventSelected: 'falta'
    }
  },
  computed: {
    ...mapState('sheet', ['lines']),
    ...mapState('verifyTimesheet', [
      'verificationKind', 'startDate', 'endDate', 'verificationFilters', 'pagination'
    ]),
    allowVerify () {
      return this.validDates
    },
    currentStep () {
      return this.kinds.findIndex(i => i.id === this.verificationKind)
    },
    currentEventStep () {
      if (!this.kinds[this.currentStep].subSteps) {
        return null
      }

      return this.kinds[4].subSteps.findIndex(i => i.id === this.verificationFilters[0].field)
    },
    tmsQuery: {
      set (value) {
        this.$store.commit('verifyTimesheet/options', {tmsQuery: value})
      },
      get () {
        return this.$store.state.verifyTimesheet.options.tmsQuery
      }
    },
    tmsIgnoreZeros: {
      set (value) {
        this.$store.commit('verifyTimesheet/options', {tmsIgnoreZeros: value})
      },
      get () {
        return this.$store.state.verifyTimesheet.options.tmsIgnoreZeros
      }
    },
    descontoBancoDeHoras: {
      set (value) {
        this.$store.commit('verifyTimesheet/options', {descontoBancoDeHoras: value})
      },
      get () {
        return this.$store.state.verifyTimesheet.options.descontoBancoDeHoras
      }
    }
  },
  methods: {
    updateVerificationFiltersState () {
      this.$store.commit('verifyTimesheet/verificationFilters', [
        { field: this.apontamentoSelected, value: this.filterValue.float }
      ])
    },
    async setVerifyKind (kind) {
      this.$store.commit('verifyTimesheet/resetPagination')
      this.$store.commit('verifyTimesheet/verificationKind', kind)

      if (kind === 'events') {
        this.$store.commit('verifyTimesheet/verificationFilters', [
          { field: 'falta', value: true }
        ])
      } else if (kind === 'timemeasurement') {
        this.$store.commit('verifyTimesheet/verificationFilters', [
          { field: 'extraTime50Tot', value: this.filterValue.float }
        ])
      }

      this.verify()
    },
    async verify (resetPagination = false) {
      if (resetPagination) {
        this.$store.commit('verifyTimesheet/resetPagination')
      }
      this.$emit('doVerify')
    },
    changeVerificationFilter () {
      console.log('changeVerificationFilter')
      if (this.verificationKind === 'timemeasurement') {
        if (isNaN(this.filterValue.float)) return
        this.$store.commit('verifyTimesheet/verificationFilters', [
          {
            value: this.filterValue.float,
            field: this.apontamentoSelected
          }
        ])
      } else {
        this.$store.commit('verifyTimesheet/verificationFilters', [
          { field: this.filterEvent, value: true }
        ])
      }
    },
    changeEventType () {
      this.$store.commit('verifyTimesheet/verificationFilters', [{
        field: this.eventSelected,
        value: true
      }])
      this.verify()
    },
    goToPage (page) {
      this.$store.commit('verifyTimesheet/pagination', { page })
      this.verify()
    },
    allowEditSheet (allow = true) {
      const lines = this.$store.getters['timesheet/sheet'].lines
      const rangeSheet = range(0, lines.length)

      this.$store.commit('timesheet/locking', !allow)
      this.$store.commit('sheet/processing', {
        types: ['lines'], [allow ? 'remove' : 'add']: rangeSheet
      })
    },
    async resolveOddPtsProblems () {
      const lines = this.$store.state.sheet.lines.map(i => i.id)

      this.allowEditSheet(false)

      try {
        const response = await this.$API.autoCorrect.save(
          {correct: 'correct'}, {lines_id: lines}
        )
        this.verify(false)
        this.$swal({
          type: 'info',
          title: '',
          text: response.data.success + ' pontos corrigidos automaticamente'
        })
      } catch (e) {
        this.$swal({
          type: 'info',
          title: '',
          text: 'Correção automatica não identificou problemas.' +
          'Lembrando que a função não corrige dias de folga, sem escalas, ou com correções manuais! '
        })
      }
      this.allowEditSheet(true)
    }
  },
  components: { ProgressSteps, Paginate }
}
</script>

<style scoped lang="scss">
.verification-wrapper {
  display: grid;
  align-items: center;
  grid-template-columns: 1fr .4fr .2fr;
  grid-column-gap: 10px;
  margin-bottom: 7px;

  .btn-13px {
    margin-bottom: 13px;
  }

  .steps {
    grid-column: 1 / 2;
  }

  .filters-box {
    grid-column: 2 / 4;
    grid-row: 1;
    align-self: start;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) min-content minmax(0, 0.5fr);
    grid-template-rows: fit-content(1fr) fit-content(1fr);
    grid-column-gap: 5px;
    align-items: flex-end;

    .ignore-zeros {
      grid-row: 2;
      grid-column: 1/2;
      align-self: flex-start;
    }

    .desconto_em_banco {
      grid-row: 2;
      grid-column: 1/2;
      align-self: flex-start;
    }

    .problems-info {
      grid-row: 2;
      grid-column: 2 / -1;
      align-self: start;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: min-content min-content min-content;
      height: 100%;

      .icon {
        margin-right: 10px;
        font-size: 30px;
        color: #CB9736;
      }
      label {
        grid-row: 1;
        display: flex;
        align-items: flex-end;
      }
      .button {
        grid-row: 2;
      }
      .paginate {
        grid-row: 3;
        // align-self: end;
      }
    }
  }
}
</style>
